import * as mutations from './mutations'
import * as actions from './actions'
import * as getters from './getters'

export default {
  namespaced: true,
  state () {
    return {
      _: {
        mandatory: {
          date: undefined,
          amount: undefined
        }
      },
      list: [
        'mandatory'
      ],
      base: undefined
    }
  },
  mutations,
  actions,
  getters
}
